import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import Routes from './Routes'

export default function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize('UA-50303477-1');
      ReactGA.pageview(window.location.pathname + window.location.search);
    }
  }, [])

  return (
    <div>
      <Routes />
    </div>
  )
}
